import { LogLevel } from '../../types';
var LoggingService = /** @class */ (function () {
    function LoggingService() {
        this.DefaultLogLevel = LogLevel.Fatal;
        // TODO: Additional methods or properties?
    }
    LoggingService.prototype.Log = function (message, logObject, level, isPrivate) {
        level = level || this.DefaultLogLevel;
        switch (level) {
            case LogLevel.Verbose:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Trace:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Debug:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            case LogLevel.Info:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.info(message, logObject);
                break;
            case LogLevel.Warn:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.warn(message, logObject);
                break;
            case LogLevel.Error:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.error(message, logObject);
                break;
            case LogLevel.Fatal:
                isPrivate = isPrivate ? isPrivate : true;
                // tslint:disable-next-line:no-console
                console.debug(message, logObject);
                break;
            default:
                isPrivate = isPrivate ? isPrivate : false;
                // tslint:disable-next-line:no-console
                console.log(message, logObject);
                break;
        }
        var applicationMessage = new CustomEvent('applicationMessage', { detail: { message: message, level: level, isPrivate: isPrivate }, composed: true });
        window.dispatchEvent(applicationMessage);
    };
    return LoggingService;
}());
var ɵ0 = function () { return window.LoggingService ? new window.LoggingService() : new LoggingService(); };
var LoggingServiceProvider = {
    provide: 'LoggingService',
    useFactory: ɵ0
};
export { LoggingServiceProvider };
export { ɵ0 };
